import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import NotFoundView from "../errors/NotFoundView";
import Edit from "./Edit";
import List from "./List";
import KubernetesSetupDialog from "./components/short_forms/kubernetes/SetupDialog";
import CreateSSHRouteWizard from "@/components/CreateSSHRouteWizard";

const View: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <Routes>
      <Route index element={<List />} />
      <Route path="create" element={<Edit />} />
      <Route path=":routeId/edit" element={<Edit />} />

      {/** TODO: Use `/setup` for all guided routes **/}
      <Route path="setup" element={<CreateSSHRouteWizard />} />
      <Route path="kubernetes-setup" element={<KubernetesSetupDialog />} />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
};

export default View;
